import { Component, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EMPTY } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { CPRCouponModalService } from 'src/app/core/services/cpr-coupon-modal.service';
import { GoogleAnalyticsService } from 'src/app/core/services/google-tag-manager.service';
import { GTMEvents } from 'src/app/model/google-tag-manager/api-status';
import { IServiceAction, IServicesOffering } from 'src/app/model/sitefinity/IServicesOffering';
import { ADPResourceService } from 'digital-core';

@Component({
  selector: 'app-tech-services-modal',
  templateUrl: './tech-services-modal.component.html',
  styleUrls: ['./tech-services-modal.component.scss'],
})
export class TechServicesModalComponent {
  @Input() modalWindowSettings: IServicesOffering;
  public redeemed: boolean = false;
  public emailNotice: boolean = false;
  public buttonDisabled: boolean = false;
  public redirectUrl: string;

  constructor(
    public dialogRef: MatDialogRef<TechServicesModalComponent>,
    private cprCouponModalService: CPRCouponModalService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private resourceService: ADPResourceService,
    @Inject(MAT_DIALOG_DATA) public modalData: any
  ) { }

  onAction(action: IServiceAction) {
    this.buttonDisabled = true;
    if (action.type === 'redirect') {
      this.redirectToUrl(action.urlId);
    } else {
      this.sendCPREmail();
    }
    this.googleAnalyticsService.emitClickEvent(GTMEvents.Click, action.buttonText, undefined, undefined, undefined, this.modalData.title);
  }

  redirectToUrl(urlcode: string): void {
    if (urlcode === 'helloTechUrl') {
      this.redirectUrl = this.redirectUrl = this.resourceService.getPortalSetting("URL_External_HelloTech").Value;;
    }
    if (urlcode === 'ptpSchedulingUrl') {
      this.redirectUrl = this.resourceService.getPortalSetting("URL_External_PTPScheduling").Value;
    }
    window.open(this.redirectUrl, '_blank');
    this.closeModal();
  }

  /**
   * @deprecated This method should not be used in any new code that is written. This is called for the old CAS clients and won't work for any of our new clients. This API call causes retrieving content (on the backend function app) from the old way of using Sitefinity and it wasn't refactored into the new way of Sitefinity. So if this method is for whatever reason needing to be used for any new client we set up, then we will need to refactor this method to pull content from the new way of doing Sitefinity (using the Portal Contents or Portal Settings or etc...). Because the goal is that when we create a new client we don't have to configure any settings in the old Sitefinity way because that would lead to confusion when creating a new client.
   */
  sendCPREmail() {
    const postData = {
      ContractId: this.modalData.contractId,
      TypeOfService: this.modalData.typeOfService,
    };

    this.cprCouponModalService.redeemCoupon(postData).pipe(
      map((response) => {
        this.emailNotice = true;
        this.redeemed = true;

      }),
      finalize(() => this.buttonDisabled = false),
      catchError(() => {
        this.emailNotice = true;
        this.redeemed = true;
        return EMPTY;
      })
    ).subscribe();
  }

  closeModal() {
    this.dialogRef.close();
  }
}
